import Default from './default';
import Primary from './primary';
import Secondary from './secondary';

const Text = {
  Default,
  Primary,
  Secondary,
};

export default Text;
